const prefixo = "saldoHomeOculto:"

function chave(idProf) {
	return prefixo + String(idProf ?? "")
}

export function lerSaldoOculto(idProf) {
	try {
		return window.localStorage.getItem(chave(idProf)) === "1"
	} catch {
		return false
	}
}

export function salvarSaldoOculto(idProf, oculto) {
	try {
		window.localStorage.setItem(chave(idProf), oculto ? "1" : "0")
	} catch {
		/* ignore */
	}
}
